/**
 * Applies or removes dark mode by toggling the "dark" class on the document root.
 * Called from screen components based on the ext-theme authorization parameter.
 *
 * @param mode - "dark" (force dark), "light" (force light), "system" (OS preference), or undefined (defaults to "system")
 */
export function applyDarkMode(mode: string | undefined): void {
  const resolvedMode = mode || "system";
  let isDark = false;

  if (resolvedMode === "dark") {
    isDark = true;
  } else if (resolvedMode === "system") {
    isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  }

  if (isDark) {
    document.documentElement.classList.add("dark");
  } else {
    document.documentElement.classList.remove("dark");
  }
}
